import { Component, Input, OnInit } from '@angular/core';
import { HasSubscriptions } from 'shared/components/higher-order/has-subscriptions';
import { SidebarService } from 'shared/services/sidebar.service';

@Component({
  selector: 'app-sidebar-nav-logo',
  templateUrl: './sidebar-nav-logo.component.html',
  styleUrls: ['./sidebar-nav-logo.component.scss'],
})
export class SidebarNavLogoComponent extends HasSubscriptions implements OnInit {
  @Input()
  collapsedImage: string;

  @Input()
  expandedImage: string;

  @Input()
  redirectionLink: string;

  @Input()
  secondaryImage: string;

  expanded: boolean;

  constructor(private sidebarService: SidebarService) {
    super();
  }

  ngOnInit() {
    this.addSubscription(
      this.sidebarService.isMenuExpanded$().subscribe(msg => (this.expanded = msg))
    );
  }
}
